import { createContext } from "react";  // es una funcion que retorna un estado

const UserContext = createContext()     // crea un contexto el cual contiene todo lo que se ha creado en UserState




export default UserContext; 